import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

const KnowledgeCenter = Loadable(lazy(() => import('views/dashboard/KnowledgeCenter/KnowledgeCenter')));
const ChannelNotifications = Loadable(lazy(() => import('views/dashboard/socialMedia/ChannelNotifications.jsx')));
const VideoDetailPage = Loadable(lazy(() => import('views/dashboard/socialMedia/VideoDetailPage.jsx')));
const IdeasPage = Loadable(lazy(() => import('views/dashboard/socialMedia/IdeasPage')));
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const PortfolioReview = Loadable(lazy(() => import('views/dashboard/PortfolioReview/index.jsx')));
const KnowledgeBaseDetail = Loadable(lazy(() => import('views/dashboard/KnowledgeCenter/components/KnowledgeBaseDetail')));

const TrackingSettings = Loadable(lazy(() => import('views/dashboard/socialMedia/TrackingSettings')));
const Mattermost = Loadable(lazy(() => import('views/dashboard/Mattermost/Mattermost')));
const InternalKitCorner = Loadable(lazy(() => import('views/dashboard/InternalKitCorner/InternalKitCorner')));

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      index: true,
      element: <Navigate to="/dashboard" replace />
    },
    {
      path: 'dashboard',
      element: <DashboardDefault />
    },
    {
      path: 'knowledge-center',
      element: <KnowledgeCenter />
    },
    {
      path: 'knowledge-center/:kbId',
      element: <KnowledgeBaseDetail />
    },
    {
      path: 'mattermost',
      element: <Mattermost />
    },
    {
      path: 'internal-kit-corner',
      element: <InternalKitCorner />
    },
    {
      path: 'social',
      children: [
        {
          index: true,
          element: <TrackingSettings />
        },
        {
          path: 'add-channel',
          element: <TrackingSettings />
        },
        {
          path: 'channel/:channelId/notifications',
          element: <ChannelNotifications />
        },
        {
          path: 'videos/:videoId',
          element: <VideoDetailPage />
        },
        {
          path: 'ideas',
          element: <IdeasPage />
        }
      ]
    },
    {
      path: 'portfolio',
      element: <PortfolioReview />
    }
  ]
};

export default MainRoutes;
